export default function SignaturePreview({ signatureData }) {
  if (!signatureData) return null;

  return (
    <div className="mt-6 border-t border-gray-200 pt-4">
      <div className="p-4 bg-white border border-gray-300 rounded-lg">
        <div className="flex items-center justify-center">
          <img 
            src={signatureData} 
            width={200}
            alt="Signature Preview" 
            className="max-w-full max-h-24 object-contain"
          />
        </div>
      </div>
      <div className="mt-2 text-xs text-gray-500">
        <p>This is how your signature will appear on documents.</p>
      </div>
    </div>
  );
}